export default __webpack_public_path__ + "static/illustration-card-one.url-7cedb4498e7b42aeae1a0bbf95805be7.svg";